import RestService from "./rest.service";

class competencyService {
  getListIdpTemplate(cycle_id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.getCompetency(`app/admin/kpi/evaluate/idp?cycle_id=${cycle_id}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  getIdpTemplate(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.getCompetency(`app/admin/kpi/evaluate/idp/${serial}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  createIdpTemplate(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/evaluate/idp/add`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  updateIdpTemplate(serial, data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.put(`app/admin/kpi/evaluate/idp/${serial}/edit`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  deleteIdpTemplate(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.delete(`app/admin/kpi/evaluate/idp/${serial}/delete`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
}

export default new competencyService();
